import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "scale-add",
  "use": "scale-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"scale-add\"><path d=\"M511.722 478.184H375.268v-68.227h136.454V273.503h68.227v136.454h136.454v68.227H579.949v136.454h-68.227V478.184z\" /><path d=\"M989.311 444.07a443.476 443.476 0 0 1-695.506 365.015 33.431 33.431 0 0 1-1.296 1.364L106.522 996.436A34.114 34.114 0 1 1 58.285 948.2l182.371-182.371A443.476 443.476 0 1 1 989.311 444.07zm-68.227 0a375.249 375.249 0 1 0-750.497 0 375.249 375.249 0 0 0 750.497 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol